import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const SignDocument = () => {
  const navigate = useNavigate();
  const [isPlacingSignature, setIsPlacingSignature] = useState(false);
  const [signature, setSignature] = useState(null);

  const documentInfo = {
    invitedBy: 'jane.doe@transferpitch.com',
    date: '11 Nov, 2024',
    message: 'Hi, please sign the documents attached.'
  };

  const handleClose = () => {
    navigate('/documents');
  };

  const handleSignNow = () => {
    setIsPlacingSignature(true);
  };

  const handleConfirmSigning = () => {
    // Handle signature confirmation
    navigate('/documents');
  };

  const handleCancel = () => {
    setIsPlacingSignature(false);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="border-b border-gray-100">
        <div className="flex items-center justify-between px-8 py-4">
          <div className="flex items-center space-x-3">
            <img src="/tp_logo.png" alt="TransferPitch" className="h-8" />
            <span className="text-sm text-gray-600">You've been invited to sign this document.</span>
          </div>
          <button
            onClick={handleClose}
            className="p-2 text-gray-400 hover:text-gray-600"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-5xl mx-auto py-8 px-4">
        <div className="mb-8">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-xl font-semibold text-gray-900 mb-2">
                {isPlacingSignature ? 'Place your visual signature' : 'Player contract agreement'}
              </h1>
              <p className="text-sm text-gray-600">
                {isPlacingSignature 
                  ? 'Drag and drop your signature to the designated spot in the document.'
                  : 'Sign, and your visual signature will appear in the designated spot. You can also drag and drop.'}
              </p>
            </div>
            {isPlacingSignature && (
              <div className="flex items-center space-x-3">
                <button
                  onClick={handleCancel}
                  className="px-4 py-2 text-sm text-gray-600 hover:text-gray-900"
                >
                  Cancel
                </button>
                <button
                  onClick={handleConfirmSigning}
                  className="px-4 py-2 text-sm text-white bg-blue-600 rounded-lg hover:bg-blue-700"
                >
                  Confirm signing
                </button>
              </div>
            )}
          </div>
          {!isPlacingSignature && (
            <div className="mt-4 bg-amber-50 p-4 rounded-lg">
              <div className="flex items-start space-x-2">
                <span className="text-sm font-medium text-gray-900">Message:</span>
                <span className="text-sm text-gray-600">{documentInfo.message}</span>
              </div>
            </div>
          )}
        </div>

        {/* Document Preview */}
        <div className="bg-white rounded-lg border border-gray-200">
          <div className="p-4 border-b border-gray-100 flex items-center justify-between text-sm text-gray-500">
            <div>Invited by: {documentInfo.invitedBy}</div>
            <div>Date: {documentInfo.date}</div>
          </div>
          <div className="p-8">
            {/* Document Content */}
            <div className="space-y-6">
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-900">Occupation:</label>
                  <div className="h-10 bg-gray-50 rounded-lg mt-1"></div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-900">Did the Player use the services of an Agent</label>
                  <div className="flex items-center space-x-4 mt-1">
                    <span className="text-sm text-gray-900">Yes/No</span>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-900">If yes, name of Agent</label>
                  <div className="h-10 bg-gray-50 rounded-lg mt-1"></div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-900">Signature of Agent</label>
                  <div className="relative mt-1">
                    <div className="h-10 border-b border-gray-300"></div>
                    {signature && (
                      <div className="absolute top-0 left-0 bg-white rounded-lg p-3 shadow-lg border border-gray-200">
                        <div className="space-y-1">
                          <div className="text-sm font-medium">John Fernandes - Head of coach</div>
                          <div className="text-xs text-gray-500">Barcelona, 11 Nov 2024</div>
                          <div className="flex items-center space-x-2 mt-2">
                            <div className="w-6 h-6 bg-blue-600 rounded-lg flex items-center justify-center text-white text-xs font-medium">
                              QES
                            </div>
                            <div className="text-xs">
                              <div className="font-medium">Qualified electronic signature - Swiss law</div>
                              <div className="text-gray-500">Signed on transferpitch.com</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-900">Did the Club use the services of an Agent</label>
                  <div className="flex items-center space-x-4 mt-1">
                    <span className="text-sm text-gray-900">Yes/No</span>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-900">If yes, name of Agent</label>
                  <div className="h-10 bg-gray-50 rounded-lg mt-1"></div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-900">Signature of Agent</label>
                  <div className="h-10 border-b border-gray-300 mt-1"></div>
                </div>
              </div>

              <div className="text-right text-sm text-gray-500">17</div>
            </div>
          </div>
        </div>

        {/* Sign Now Button */}
        {!isPlacingSignature && (
          <div className="mt-6 flex justify-end">
            <button
              onClick={handleSignNow}
              className="px-6 py-2 text-sm text-white bg-blue-600 rounded-lg hover:bg-blue-700"
            >
              Sign now
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SignDocument; 